import * as React from "react";
const Clock = (props) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11C0 4.9247 4.9247 0 11 0C17.0753 0 22 4.9247 22 11C22 17.0753 17.0753 22 11 22C4.9247 22 0 17.0753 0 11ZM11 6.6C11 6.30826 10.8841 6.02847 10.6778 5.82218C10.4715 5.61589 10.1917 5.5 9.9 5.5C9.60826 5.5 9.32847 5.61589 9.12218 5.82218C8.91589 6.02847 8.8 6.30826 8.8 6.6V12.1C8.8 12.3917 8.91589 12.6715 9.12218 12.8778C9.32847 13.0841 9.60826 13.2 9.9 13.2H15.4C15.6917 13.2 15.9715 13.0841 16.1778 12.8778C16.3841 12.6715 16.5 12.3917 16.5 12.1C16.5 11.8083 16.3841 11.5285 16.1778 11.3222C15.9715 11.1159 15.6917 11 15.4 11H11V6.6Z"
      fill="#EEEEEE"
    />
  </svg>
);
export default Clock;
